<template>
  <b-row>
    <b-col cols="4">
      <label class="labeled-info-label"> {{ label }}: </label>
    </b-col>
    <b-col class="labeled-info-img-container" v-if="type === 'img'">
      <b-img class="labeled-info-img" :src="value" />
    </b-col>
    <b-col v-else class="labeled-info-value" cols="8">
      {{ formattedValue }}
    </b-col>
  </b-row>
</template>

<script>
import {
  standardFormatter,
  moneyFormatter,
  dateFormatter,
  percentageFormatter,
  ssnFormatter,
  phoneFormatter
} from '@/utils/formatters'

export default {
  props: {
    label: String,
    value: [String, Boolean, Number],
    type: {
      default: 'standard',
      type: String
    }
  },
  computed: {
    formattedValue() {
      switch (this.type) {
        case 'standard':
          return standardFormatter(this.value)
        case 'money':
          return moneyFormatter(this.value)
        case 'date':
          return dateFormatter(this.value)
        case 'percentage':
          return percentageFormatter(this.value)
        case 'ssn':
          return ssnFormatter(this.value)
        case 'phone':
          return phoneFormatter(this.value)
        default:
          return this.value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.labeled-info-img-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 35px;
}
</style>
